import React, { useState, useEffect } from "react"
import { DndContext, closestCenter, useSensor, useSensors, PointerSensor, TouchSensor, MouseSensor } from "@dnd-kit/core"
import { SortableContext, useSortable, horizontalListSortingStrategy, arrayMove } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import { restrictToHorizontalAxis } from "@dnd-kit/modifiers"

function SortableTag({ item, index, removeAction, renderTagContent }) {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: item.id })

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        cursor: 'grab',
        marginRight: '0.5rem'
    }

    return (
        <span
            ref={setNodeRef}
            {...attributes}
            className="tag is-warning"
            style={style}
        >
            <span {...listeners}>
                {renderTagContent ? renderTagContent(item) : item.name}
            </span>

            <button
                className="delete is-small"
                onClick={() => removeAction(index)}
            />
        </span>
    )
}

export default function DraggableTagList({ itemList, removeAction, saveOrder, renderTagContent }) {
    const [tags, setTags] = useState([])

    useEffect(() => {
        console.log(itemList)
        if (itemList) {
            const listWithIds = itemList.map((item, i) => {
                return {
                    ...item,
                    id: i
                }
            })
            setTags(listWithIds)
        }
    }, [itemList])

    const sensors = useSensors(useSensor(MouseSensor), useSensor(TouchSensor, {
        activationConstraint: {
            delay: 100,
            tolerance: 8
        }
    }))

    const handleDragEnd = (e) => {
        const { active, over } = e

        if (!over || active.id === over.id) return

        const oldIndex = tags.findIndex(tag => tag.id === active.id)
        const newIndex = tags.findIndex(tag => tag.id === over.id)

        const updatedTags = arrayMove(tags, oldIndex, newIndex)

        setTags(updatedTags)
        saveOrder(updatedTags)
    }

    return (
        <>
            {tags && tags.length > 0 && (
                <div className="field">
                    <div className="control">
                        <DndContext
                            sensors={sensors}
                            collisionDetection={closestCenter}
                            onDragEnd={handleDragEnd}
                            modifiers={[restrictToHorizontalAxis]}
                        >
                            <SortableContext
                                items={tags.map(tag => tag.id)}
                                strategy={horizontalListSortingStrategy}
                            >
                                <div
                                    className="tags"
                                    style={{
                                        display: "flex",
                                        flexWrap: "nowrap",
                                        overflowX: "auto"
                                    }}
                                >
                                    {tags.map((item, index) => (
                                        <SortableTag
                                            key={item.id}
                                            item={item}
                                            index={index}
                                            removeAction={removeAction}
                                            renderTagContent={renderTagContent}
                                        />
                                    ))}
                                </div>
                            </SortableContext>
                        </DndContext>
                    </div>
                </div>
            )}
        </>
    );
}